export const IMAGE_SERVICE_ROUTES = {
  UPLOAD: '/image-service',
} as const;
